export default __webpack_public_path__ + "static/media/Kannada_bm_1.8311452f.mp3";